import React from 'react'
import { Badge } from 'react-bootstrap'
import { Zap } from 'lucide-react'
import styled from 'styled-components'
import { StepComponentProps } from '../types'

const ComingSoonPlaceholder = styled.div`
  background: #2a2a2a;
  border-radius: 12px;
  padding: 3rem;
  text-align: center;
  border: 2px dashed #555;
  margin: 2rem 0;

  h3 {
    color: #fff;
    margin-bottom: 1rem;
  }

  p {
    color: #888;
    margin-bottom: 0;
  }
`

type ChallengesStepProps = StepComponentProps

const ChallengesStep: React.FC<ChallengesStepProps> = ({ stepData, onNext, onBack }) => {
  // TODO: Implement challenges selection functionality
  // This could include:
  // - Weather conditions (rain, snow, fog, etc.)
  // - Lighting variations (dawn, dusk, night, artificial lighting)
  // - Environmental challenges (dust, smoke, glare)
  // - Difficulty settings

  return (
    <ComingSoonPlaceholder>
      <Zap size={48} style={{ color: '#666', marginBottom: '1rem' }} />
      <h3>Environmental Challenges</h3>
      <p>
        Add weather conditions, lighting variations, and environmental challenges to make your
        synthetic data more realistic and challenging.
      </p>
      <div className="mt-4">
        <p className="text-muted small">
          <strong>Future Features:</strong>
        </p>
        <ul className="text-muted small text-start" style={{ maxWidth: '400px', margin: '0 auto' }}>
          <li>Weather conditions (Rain, Snow, Fog, Storm, etc.)</li>
          <li>Lighting variations (Dawn, Dusk, Night, Artificial)</li>
          <li>Environmental effects (Dust, Smoke, Glare, Shadows)</li>
          <li>Visibility challenges (Low light, Camouflage)</li>
          <li>Difficulty level presets</li>
        </ul>
      </div>
      <Badge bg="secondary" className="mt-3">
        Coming Soon
      </Badge>
    </ComingSoonPlaceholder>
  )
}

export default ChallengesStep
